export const TOURNAMENT_QUERY_KEYS = {
	TOURNAMENTS: {
		ALL: ['tournaments'] as const,
		LIST: (query?: Record<string, unknown>) =>
			[...TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL, 'list', query] as const,
		DETAIL: (id: string) =>
			[...TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL, 'detail', id] as const,
		PLAYERS: (id: string, query?: Record<string, unknown>) =>
			[...TOURNAMENT_QUERY_KEYS.TOURNAMENTS.ALL, id, 'players', query] as const,
		PRESETS: [...['tournaments'], 'presets'] as const,
	},
} as const

export const TOURNAMENT_STATUS_OPTIONS = [
	{ value: 'DRAFT', label: 'ฉบับร่าง' },
	{ value: 'ACTIVE', label: 'กำลังดำเนินการ' },
	{ value: 'ENDED', label: 'สิ้นสุดแล้ว' },
	{ value: 'CANCELLED', label: 'ยกเลิก' },
]

export const TOURNAMENT_PLAYER_STATUS_OPTIONS = [
	{ value: 'PENDING', label: 'รอดำเนินการ' },
	{ value: 'QUALIFIED', label: 'ผ่านคุณสมบัติ' },
	{ value: 'ACTIVE', label: 'กำลังแข่งขัน' },
	{ value: 'DISQUALIFIED', label: 'ถูกตัดสิทธิ์' },
	{ value: 'COMPLETED', label: 'เสร็จสิ้น' },
]

export const TOURNAMENT_STATUS_BADGE_MAP: Record<
	string,
	'default' | 'secondary' | 'destructive'
> = {
	DRAFT: 'secondary',
	ACTIVE: 'default',
	ENDED: 'default',
	CANCELLED: 'destructive',
}

export const TOURNAMENT_PLAYER_STATUS_BADGE_MAP: Record<
	string,
	'default' | 'secondary' | 'destructive'
> = {
	PENDING: 'secondary',
	QUALIFIED: 'default',
	ACTIVE: 'default',
	DISQUALIFIED: 'destructive',
	COMPLETED: 'default',
}
